<script>
import * as ReviewTypeElements from '../../variables/reviewElementTypes';
import ReviewService from '../../services/review-service';

export default {
  name: 'ReviewRatingsContainerAlternative',
  props: {
    categoryRatings: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      campsiteCategories: this.getCampsiteCategories(this.categoryRatings),
    };
  },
  methods: {
    getCampsiteCategories(categoryRatings) {
      return categoryRatings.filter(
        element => element.category === ReviewTypeElements.REVIEW_RATINGS_DK,
      );
    },
    doubleRoundScore(score) {
      return ReviewService.doubleRoundScore(score);
    },
  },
};
</script>

<template>
  <div>
    <v-card-text class="mx-2">
      <v-layout>
        <v-flex>
          <h3>{{ $t('review.reviewInformationContainer.campsiteRatings')}}</h3>
          <br>
          <div v-for="campsiteCategory in campsiteCategories" :key="campsiteCategory.id">
            <v-layout>
              <v-flex>
                {{ campsiteCategory.type }}
              </v-flex>
              <v-flex xs2>
                {{ doubleRoundScore(campsiteCategory.score) }}
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider class="mx-3"/>
  </div>
</template>



// WEBPACK FOOTER //
// src/components/review/ReviewRatingsContainerAlternative.vue